import { render, staticRenderFns } from "./PhoneSignUp.vue?vue&type=template&id=d3bf1ad4&scoped=true&"
import script from "./PhoneSignUp.vue?vue&type=script&lang=js&"
export * from "./PhoneSignUp.vue?vue&type=script&lang=js&"
import style0 from "./PhoneSignUp.vue?vue&type=style&index=0&id=d3bf1ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bf1ad4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardActions,VCheckbox,VIcon,VProgressLinear,VTextField})
